export const environment: any = {
    frontUrl: 'https://diag.itsense.fr/',
    apiUrl: 'https://api-diag.itsense.fr'
};
